export function reduceTurn(state, action) {
  switch (action.type) {
    case 'TURN_STARTED':
      return Object.assign({}, state, {
        conversationId: action.conversationId,
        turnId: action.turnId
      }, action.title !== undefined ? {
        title: action.title
      } : {});
    case 'TURN_COMPLETED':
      return Object.assign({}, state, {
        status: 'READY',
        isReconnecting: false
      });
    case 'TURN_ERROR':
      return Object.assign({}, state, {
        status: 'ERROR',
        error: action.error,
        isReconnecting: false
      });
    case 'TURN_ERROR_SOFT':
      return Object.assign({}, state, {
        error: action.error
      });
    case 'STATUS_SET':
      return Object.assign({}, state, {
        status: action.status
      });
    case 'RESET_TURN':
      return Object.assign({}, state, {
        conversationId: null,
        turnId: null
      });
    case 'CANCEL_MARK':
      return Object.assign({}, state, {
        cancelled: true
      });
    case 'CANCEL_CLEAR':
      return Object.assign({}, state, {
        cancelled: false
      });
    case 'RECONNECTING_SET':
      return Object.assign({}, state, {
        isReconnecting: true
      });
    case 'TITLE_UPDATED':
      return Object.assign({}, state, {
        title: action.title
      });
    case 'RESET':
      return Object.assign({}, state, {
        conversationId: null,
        turnId: null,
        title: null,
        status: 'READY',
        error: null,
        cancelled: false,
        isReconnecting: false
      });
    default:
      return state;
  }
}